<div class="overlay1">
    <div class="twitter-like">
        <mat-spinner style="opacity: 0.3;" class="center" diameter="70" mode="determinate" value="100" aria-label="Spinner">
        </mat-spinner>
        <mat-spinner mode="indeterminate" diameter="70" class="center" aria-label="Spinner"></mat-spinner>
    </div>
    <div *ngIf="progress == 0" class="spinner-text">Loading...</div>
    <div *ngIf="progress > 0" class="spinner-text"> Progress: {{progress}}% </div>

</div>